import { render } from "./Header.vue?vue&type=template&id=deafa7ba&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=deafa7ba&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/hapi/hapi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deafa7ba"]])

export default __exports__